module.exports = __webpack_public_path__ + "img/rule1.1cc84513.png";